<template>
  <div
    ref="carousel"
    v-if="cardItems.length > 0"
  >

    <section style="position:relative">
      <ACarousel
        :options="swiperOptions"
        class="featured-swiper"
        :hide-arrows="!this.carouselSettings.arrows.value"
        :hide-pagination="!this.carouselSettings.pills.value"
      >
        <ACarouselSlide
          v-for="(item, key) in cardItems"
          :key="key"
          :index="key"
          :ssr-slide-number="2"
        >
          <card-item
            :item="item"
            :filestore="filestore"
          />

        </ACarouselSlide>
        <div
          v-if="carouselSettings.pills.value"
          slot="pagination"
          class="swiper-pagination"
        />
        <div
          v-if="carouselSettings.arrows.value"
          slot="button-prev"
          class="swiper-button-prev swiper-button-white swiper-arrow"
        />
        <div
          v-if="carouselSettings.arrows.value"
          slot="button-next"
          class="swiper-button-next swiper-button-white swiper-arrow"
        />
      </ACarousel>
    </section>
  </div>
</template>

<script>
import cardItem from "../layouts/cards/card-content-carousel.vue";
// import FilestorePresignedURL from "../filestore-presigned-url";

export default {
  components: {
    cardItem
  },
  // mixins: [FilestorePresignedURL],
  props: {
    widget: {
      type: Object,
      required: true
    },
    filestore: {
      type: [Object, String],
      required: true
    }
  },
  data() {
    return {
      errors: [],
      items: [],
      host: "",
      background: [],
      swiperOptions: {
        loopAdditionalSlides: 10,
        init: true,
        observer: true,
        observeParents: true
      }
    };
  },
  computed: {
    widgetSettings: function() {
      return this.widget.widgetSettings;
    },
    cardItems: function() {
      return this.widget.cardItems.filter(item => item.cardType !== 'empty' && item.gridId == null);
    },
    selectedWidget: function() {
      return this.widget.widgetSettings.selectedWidget;
    },
    carouselSettings: function() {
      return this.widget.widgetSettings.carouselSettings;
    }
  },
  watch: {
    carouselSettings: {
      handler() {
        this.updateProps();
      },
      deep: true
    }
  },
  created() {
    this.setOptions();
    // this.updateCardItemThumbnails();
  },
  methods: {
    getTop(elem) {
      var box = elem.getBoundingClientRect();
      var body = document.body;
      var docEl = document.documentElement;
      var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
      var clientTop = docEl.clientTop || body.clientTop || 0;
      var top = box.top + scrollTop - clientTop;
      return Math.round(top);
    },
    // updateCardItemThumbnails: function() {
    //   let self = this;
    //   this.cardItems.forEach((card, idx) => {
    //     if (card.fileStore) {
    //       this.getPreSignedURL(card).then(data => {
    //         self.$set(self.cardItems[idx], "cardBackgroundUrl", data);
    //       });
    //     }
    //   });
    // },
    setOptions() {
      this.$set(this.swiperOptions, 'slidesPerView', 1);
      this.$set(this.swiperOptions, 'spaceBetween', 0);
      this.$set(this.swiperOptions, "loop", this.carouselSettings.loop.value);
      this.$set(
        this.swiperOptions,
        "effect",
        this.carouselSettings.fade.value ? "fade" : false
      );

      if (this.carouselSettings.autoplay.value) {
        this.$set(this.swiperOptions, "autoplay", {
          delay: this.carouselSettings.delay.value
        });
      } else {
        this.$set(this.swiperOptions, "autoplay", false);
      }
    },
    updateProps () {
      this.setOptions();
    }
  }
};
</script>

<style lang="scss">
@import '~@scss/custom.scss';

//v.8
//we're defining some base variable defaults that can be overriden outside of this layout component
//the overrides must be sourced from a file referenced in this component eg, custom.scss

//future updates, considerations for more gradient positions

//swiper core variables
$swiper-min-height-sm: 240px !default;
$swiper-min-height-md: 440px !default;
$swiper-background-color: $secondary !default;
$swiper-centered-content-padding: 4em 0em !default;
$swiper-image-overlay-tint: $black !default;

//banner content stuff
$banner-content-title-weight: 600 !default;
$banner-content-title: 3em !default;
$banner-content-description: 1.2em !default;
$banner-content-gradient-tint-color: $black !default;

//padding
$banner-content-padding: 2em !default; // multipler of

//banner buttons
$banner-button-font-size: 1.1em !default;
$banner-button-border-radius: 6px !default;
$banner-button-primary-background-color: $primary !default;
$banner-button-primary-text-color: $white !default;

$banner-button-secondary-background-color: transparent !default;
$banner-button-secondary-text-color: $white !default;

//custom swiper styling for hero bannner -----------------------------
.featured-swiper {
  width: 100%;
  .swiper-slide {
    /*background-color: $swiper-background-color; */
    flex-grow: initial;
    height: auto;
    min-height: $swiper-min-height-sm;
    @include media-breakpoint-down(md) {
      min-height: $swiper-min-height-md;
    }
  }
}
</style>
